import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const EmailReportLink = lazy(() =>
  import(/* webpackChunkName: "EmailReportLink" */ '../../components/survey_editor/email_report_link/EmailReportLink')
);

export default function AsyncEmailReportLink({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <EmailReportLink {...props} />
    </Suspense>
  );
}
